var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      attrs: {
        label: _vm.$t.__("companysearch.GB_form.company_name"),
        prop: "search"
      }
    },
    [
      _c("el-input", {
        staticClass: "valign-middle",
        class: { "w-5": _vm.inline },
        attrs: {
          prop: "search",
          disabled: !_vm.providerEnabled,
          id: "search",
          placeholder: _vm.$t.__(
            "companysearch.GB_form.enter_company_informations"
          )
        },
        nativeOn: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("search-companies")
          }
        },
        model: {
          value: _vm.form.search,
          callback: function($$v) {
            _vm.$set(_vm.form, "search", $$v)
          },
          expression: "form.search"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }